

export enum ExecuteVisitType {
    SessionDetails = 'SessionDetails',
    FinalReport = 'FinalReport',
    InstitutionEntries = 'InstitutionEntries',
    FinalReportWithInstitutionEntries = 'FinalReportWithInstitutionEntries'
}

export enum EvaluatedSummaryType {
    All = 'All',
    AllSummary = 'AllSummary',
    OnlyCriterionSummary = 'OnlyCriterionSummary',
}